export function hasValidationMessages(
  ...messageGroups: Array<unknown[] | undefined>
): boolean {
  return messageGroups.some((messages) => Boolean(messages?.length));
}
